export const ExperienceList = [
  {
    company: "Government of Nova Scotia",
    role: "Senior Application Developer/Analyst",
    Responsibilities: [
      `Develop enterprise full-stack applications using .NET Core, ASP.NET, Angular, and SQL Server.`,
      `Build secure RESTful APIs aligned with government compliance and security standards.`,
      `Translate business requirements into scalable technical solutions and system designs.`,
      `Optimize database performance through query tuning and schema improvements.`,
      `Maintain and enhance production systems to improve reliability and usability.`,
    ],
    date: "OCT 2024 - Present",
  },
  {
    company: "IBM Canada",
    role: "Application Developer",
    Responsibilities: [
      `Consulted as a developer for multiple client projects in various sectors such as finance, and the public sector, helping to develop new,
         or maintain existing systems.`,
      `Built backend microservices from the ground up, whilst following best practices to ensure the development of well rounded and secure applications.`,
      `Built web pages for different web applications and developing reusable components to improve development and reusability of code.`,
      `Constant growth through self guided learning and obtaining certifications to further broaden my skill set.`,
    ],
    date: "DEC 2021 - OCT 2024",
  },
  {
    company: "Web.com",
    role: "Marketing Consultant",
    Responsibilities: [
      `Helping clients acquire the tools they need to establish a
        strong and secure web presence.`,
      `Achieved client vision and marketing objectives by
        collaborating with different departments.`,
      `Studied demographic data to determine optimal targets,
        competitor offerings and tactics for persuasion.`,
      `Created customized marketing materials to increase
        product awareness.`,
      `Consulted with clients on business issues and developed
        innovative, high impact proposals.`,
    ],
    date: "SEP 2020 - NOV 2021",
  },
  {
    company: "Concentrix",
    role: "Technical Support Specialist",
    Responsibilities: [
        `Maintained energy and enthusiasm in a fast-paced work
        environment.`,
        `Offered friendly and efficient service to customers,
        handled challenging situations with ease.`,
        `Maintained excellent attendance record, consistently
        arriving to work on time.`,
        `Broke down and evaluated user problems, using test
        scripts, personal expertise and probing questions.`,
        `Collaborated with vendors to locate replacement
        components and resolve advanced problems.`
    ],
    date: "JUL 2020 - SEP 2020",
  },
  {
    company: "Independent Project",
    role: "Javascript Developer",
    Responsibilities: [
        `This was an independent project, developing a mobile
        application to assist restaurants with handling customer
        orders for overall smoother service.`,
        `Used technologies such as Vue.js, Framework 7, and
        Cordova for the native mobile front end, and Firebase for
        the back end.`
    ],
    date: "JAN 2020 - APR 2020",
  },
  {
    company: "Independent Project",
    role: "Javascript Developer",
    Responsibilities: [
        `This was a project working with a small team to develop
        a mobile app for finding restaurants that may be of
        interest to you in your area.`,
        `The app made use of Googles Geolocation API, and was
        built using Vue.js, Framework 7, and Cordova.`
    ],
    date: "SEP 2019 - DEC 2019",
  },
  {
    company: "Telnet Nigeria",
    role: "Intern",
    Responsibilities: [
        `Completed projects within different departments.`,
        `Network Solutions: learning the inner workings of the
        networks within the company, how they are managed,
        and maintained.`,
        `Soft works, Business Applications: developed an API in
        C# to simulate a logging system for a revolving door,
        while making constant adaptations based on client
        needs.`,
        `Special projects: Developing a TODO API using Pythons
        Django restful framework.`,
        `Telnet Network Services: Learning how the company provides and manages different network services for a variety of different clients.`
    ],
    date: "JUN 2019 - AUG 2019",
  },
  {
    company: "Independent Project",
    role: "Javascript Developer",
    Responsibilities: [
        `This was a project working alongside a small team to build a web app for finding universities that a prospective student might be interested in, 
        allowing them to swipe to save them to their favourites.`,
        `The Application was built using Vue.js with the Vuetify framework, for the front-end, and Node.js with MongoDB for the backend.`
    ],
    date: "SEP 2018 - DEC 2018",
  },
];
